import React, { Component } from 'react';

import SavingsComponent from './SavingsComponent';
import PeriodComponent from './PeriodComponent';
import BBADetailsComponent from './BBADetailsComponent';

class BalanceByAccount extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         loading: true,
    //         member: null
    //     }
    // }

    // static getDerivedStateFromProps(props, state) {
    //     const member = props.member;
    //     return {
    //         member: member
    //     }
    // }
    render() {
        return (
            <div>
                <SavingsComponent {...this.props} />
                <PeriodComponent {...this.props} />
                <BBADetailsComponent {...this.props} />
            </div>
        )
    }
}

export default BalanceByAccount;